import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import DialogWithdrawal from '../../../components/dialog-withdrawal';
import WithdrawFeeScheduleBox from '../../../components/withdraw-fee-schedule/withdraw-fee-schedule';
import { fetchWithdrawalHistory } from '../../../api/payment/transaction.api';
import DepositHistory from './DepositHistory';
import { EmptyComponent } from '../../../components/empty/empty-component';
import { Pagination, Spin } from 'antd';

interface WithdrawalRecord {
  id: string;
  amount: number;
  receivedAmount: number;
  status: string;
  createdAt: string;
  bankAccountNumber: string;
  bankName: string;
  bankAccountName: string;
  note: string;
}

const WithdrawalHistory: React.FC = () => {
  const [withdrawals, setWithdrawals] = useState<WithdrawalRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  console.log('sssssssss', loading);
  useEffect(() => {
    const getWithdrawalHistory = async () => {
      setLoading(true);
      try {
        const response = await fetchWithdrawalHistory(currentPage, pageSize);
        setWithdrawals(response.items || []);
        setTotal(response.totalItems || 0);
      } catch (error) {
        console.error('Error fetching withdrawal history:', error);
      } finally {
        setLoading(false);
      }
    };
    getWithdrawalHistory();
  }, [currentPage, pageSize]);

  // Số tiền rút lưu bằng Ca → hiển thị "... ca"
  const fmtCa = (n: number) => `${Number(n).toLocaleString('vi-VN')} ca`;

  return (
    <div className="flex flex-col gap-3">
      <DepositHistory />
      <WithdrawFeeScheduleBox collapsible />
      <div className="flex flex-col border border-[#DEE0E6] dark:border-slate-700 rounded-xl relative min-w-0 break-words bg-white shadow-xl dark:bg-slate-850 dark:shadow-dark-xl bg-clip-border">
        <div className="flex justify-between items-center p-3">
          <span className="text-[22px] leading-[27px] text-[#18191E]  font-semibold  dark:text-white">
            Lịch sử quyết toán thù lao
          </span>
          <DialogWithdrawal onCancel={() => {}} />
        </div>
        {loading ? (
          <div className="min-h-[212px] flex justify-center items-center">
            <Spin />
          </div>
        ) : withdrawals.length && withdrawals.length > 0 ? (
          <div className="overflow-x-auto bg-[#F6F7F8] px-3">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Số Ca
                  </th>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Số Ca nhận được
                  </th>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ngân hàng
                  </th>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Số tài khoản
                  </th>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Tên tài khoản
                  </th>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Trạng thái
                  </th>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Thời gian
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 dark:bg-slate-850">
                {withdrawals.map((withdrawal) => (
                  <tr key={withdrawal.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                      {fmtCa(withdrawal.amount)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                      {fmtCa(withdrawal.receivedAmount)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                      {withdrawal.bankName}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                      {withdrawal.bankAccountNumber}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                      {withdrawal.bankAccountName}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <span
                        className={`py-1 px-6 font-semibold ${
                          withdrawal.status === 'Submitted'
                            ? 'text-yellow-600 bg-yellow-100 rounded-full px-3 inline-block'
                            : withdrawal.status === 'Done'
                            ? 'text-green-600 bg-green-100 rounded-full px-3 inline-block'
                            : 'text-red-600 bg-red-100 rounded-full px-3 inline-block'
                        }`}
                      >
                        {/* Máy chủ trả Submitted | Done | Rejected (trước đây so nhầm chữ "Completed"). */}
                        {withdrawal.status === 'Submitted'
                          ? 'Đang xử lý'
                          : withdrawal.status === 'Done'
                          ? 'Đã chuyển khoản'
                          : withdrawal.status === 'Rejected'
                          ? 'Không được duyệt'
                          : withdrawal.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                      {dayjs(withdrawal.createdAt).format(
                        'DD/MM/YYYY HH:mm:ss'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <EmptyComponent customClass="bg-[#F6F7F8]" />
        )}

        <div className="flex w-full p-3 rounded-b-lg bg-white justify-end items-center dark:bg-slate-850">
          <Pagination
            current={currentPage}
            total={total}
            pageSize={pageSize}
            showSizeChanger
            onChange={(page, size) => {
              setCurrentPage(page);
              setPageSize(size);
            }}
            locale={{ items_per_page: '/trang' }}
          />
        </div>
      </div>
    </div>
  );
};

export default WithdrawalHistory;
